const constantes = {
  modalidadeBaseCalculoList: [
    { codigo: "0", descricao: "Preço Tabelado ou Máximo Sugerido" },
    { codigo: "1", descricao: "Lista Negativa (Valor)" },
    { codigo: "2", descricao: "Lista Positiva (Valor)" },
    { codigo: "3", descricao: "Lista Neutra (Valor)" },
    { codigo: "4", descricao: "Margem Valor Agregado (%)" },
    { codigo: "5", descricao: "Pauta (Valor)" },
    { codigo: "6", descricao: "Valor da Operação" },
  ],
  modalidadeBaseCalculoMva: "4",
  modalidadeBaseCalculoPauta: "5",
  calculaSubstituicao: [
    "modalidadeBaseCalculo",
    "reducaoBaseSt",
    "aliquotaSt",
    "aliquotaMva",
    "valorDePauta",
    "ipiNaBaseSt",
    "freteNabaseSt",
    "seguroNabaseSt",
    "despesaNaBaseSt",
    "descontoNaBaseSt",
    "acrescimoNaBaseSt",
  ],
  classificacoesCredPresIbsZfm: [
    { id: 0, codigo: "0", descricao: "Sem crédito presumido" },
    { id: 1, codigo: "1", descricao: "Bens de consumo final (55%)" },
    { id: 2, codigo: "2", descricao: "Bens de capital (75%)" },
    { id: 3, codigo: "3", descricao: "Bens intermediários (90,25%)" },
    { id: 4, codigo: "4", descricao: "Bens de informática e outros (100%)" },
  ],
};

export default constantes;
